export default function TrustSection() {
  return (
    <section id="about" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24">
          <div className="flex-1">
            <span className="text-xs font-medium text-primary-500 tracking-widest uppercase">
              About Hipobuy Spreadsheet
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mt-4 leading-tight">
              What Is{' '}
              <span className="italic font-normal">Hipobuy Spreadsheet</span>?
            </h2>
            <p className="mt-6 text-foreground-600 leading-relaxed text-base md:text-lg max-w-xl">
              Hipobuy Spreadsheet is a structured product research resource that helps shoppers organize product information, compare options, review important details, and make smarter purchasing decisions. Instead of manually searching hundreds of products, spreadsheet-based research allows users to access organized information in one place — saving time and reducing the guesswork involved in online shopping.
            </p>
            <p className="mt-4 text-foreground-500 leading-relaxed text-base">
              Whether you are a first-time buyer exploring new categories or an experienced shopper looking for the latest verified finds, the Hipobuy Spreadsheet approach transforms scattered product listings into a clear, navigable research tool. Every entry is curated to surface the most relevant details you need before making a purchase.
            </p>
          </div>

          <div className="flex-1">
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-background-50 rounded-2xl p-6 md:p-8">
                <span className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">10K+</span>
                <p className="text-sm text-foreground-500 mt-2">Curated Products</p>
              </div>
              <div className="bg-background-50 rounded-2xl p-6 md:p-8">
                <span className="font-heading text-4xl md:text-5xl font-bold text-accent-500">500+</span>
                <p className="text-sm text-foreground-500 mt-2">Categories Covered</p>
              </div>
              <div className="bg-background-50 rounded-2xl p-6 md:p-8">
                <span className="font-heading text-4xl md:text-5xl font-bold text-primary-500">99%</span>
                <p className="text-sm text-foreground-500 mt-2">Accuracy Rate</p>
              </div>
              <div className="bg-background-50 rounded-2xl p-6 md:p-8">
                <span className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">24/7</span>
                <p className="text-sm text-foreground-500 mt-2">Live Updates</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {[
            {
              icon: 'ri-flashlight-line',
              title: 'Faster Discovery',
              desc: 'Compare products efficiently without wasting time on endless scrolling.',
            },
            {
              icon: 'ri-scales-3-line',
              title: 'Better Decisions',
              desc: 'Review important information side by side before purchasing.',
            },
            {
              icon: 'ri-folder-chart-line',
              title: 'Organized Research',
              desc: 'Keep products, categories, and notes structured in one place.',
            },
            {
              icon: 'ri-user-heart-line',
              title: 'Beginner Friendly',
              desc: 'Learn how spreadsheet shopping works step by step with clear guides.',
            },
            {
              icon: 'ri-shield-check-line',
              title: 'Verified Resources',
              desc: 'Access updated and community-reviewed product information.',
            },
          ].map((item) => (
            <div key={item.title} className="bg-background-50 rounded-2xl p-6 card-hover cursor-default">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
              <p className="text-sm text-foreground-500 mt-2 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}